<app-confirmation-modal>
  <ng-container header>
    <h1>Terms Of Use</h1>
  </ng-container>

  <ng-container subHeader>
    <p>Here's what you need to know about your terms of use.</p>
  </ng-container>

  <ng-container content>
    <app-scrollable-text-box [contentMarkup]="(termsAndConditionsConsent$ | async)?.presentHtml">
    </app-scrollable-text-box>
  </ng-container>

  <ng-container actionButton>
    <app-button type="tertiary" (buttonClick)="back()" [dataTestId]="'terms-of-use-back'">
      Go Back
    </app-button>

    <app-button type="primary" (buttonClick)="accept()" [dataTestId]="'terms-of-use-agree'">
      Agree
    </app-button>
  </ng-container>
</app-confirmation-modal>
